import { getRouteApi } from '@tanstack/react-router';
import { useCallback } from 'react';

import { ApiConsoleScreen } from './ApiConsoleScreen';
import type { ApiConsoleSearch } from './api-console-search';

const route = getRouteApi('/api-console');

export function ApiConsoleRoute() {
  const search = route.useSearch();
  const navigate = route.useNavigate();

  const onSearchChange = useCallback(
    (next: ApiConsoleSearch) => {
      void navigate({
        replace: true,
        search: () => ({
          ...(next.q === undefined ? {} : { q: next.q }),
          ...(next.op === undefined ? {} : { op: next.op }),
        }),
      });
    },
    [navigate],
  );

  return <ApiConsoleScreen search={search} onSearchChange={onSearchChange} />;
}
